module.exports = __webpack_public_path__ + "static/media/check-mark.d511e6cc.svg";